import { useState } from "react";
import DesktopFormStepper from "../components/Steppers/DesktopFormStepper";
import MobileFormStepper from "../components/Steppers/MobileFormStepper";
import { useMobileView } from "../utils/ViewContext";
import ApplicantDetailsForm from "./Forms/ApplicantDetailsForm";
import AttachmentsForm from "./Forms/AttachmentsForm";
import MultipleFormsContainer from "./MultipleFormsContainer";
import { Paper, Theme } from "@mui/material";
import { formState } from "../states/FormState";
import { makeStyles } from "@mui/styles";
import axios from "axios";

interface ITempObj {
  [key: string]: any;
}

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    width: "80vw",
    margin: "25px auto",
    padding: "20px",

    [theme.breakpoints.down("md")]: {
      width: "90vw",
    },
  },
}));

function FormStepper() {
  const isMobile = useMobileView();

  const [activeStep, setActiveStep] = useState(0);
  const [refNumber, setRefNumber] = useState<string>("");
  const [loading, setLoading] = useState(false);

  const [values, setValues] = useState(formState);

  const [applicantErrors, setApplicantErrors] = useState<any>({});
  const [educationErrors, setEducationErrors] = useState<any[]>([{}]);
  const [experienceErrors, setExperienceErrors] = useState<any[]>([{}]);
  const [attachmentsErrors, setAttachmentsErrors] = useState<any>({});

  const [countries, setCountries] = useState<{ id: number; name: string }[]>(
    []
  );
  const [states, setStates] = useState<{ id: number; name: string }[]>([]);
  const [cities, setCities] = useState<{ id: number; name: string }[]>([]);
  const [jobTypes, setJobTypes] = useState<{ id: number; name: string }[]>([]);
  const [designations, setDesignations] = useState<
    { id: number; name: string }[]
  >([]);

  const classes = useStyles();

  const steps = [
    {
      label: "Applicant Details",
      form: (
        <ApplicantDetailsForm
          values={values}
          setValues={setValues}
          errors={applicantErrors}
          countries={countries}
          setCountries={setCountries}
          states={states}
          setStates={setStates}
          cities={cities}
          setCities={setCities}
          jobTypes={jobTypes}
          setJobTypes={setJobTypes}
          designations={designations}
          setDesignations={setDesignations}
        />
      ),
    },
    {
      label: "Education Details",
      form: (
        <MultipleFormsContainer
          values={values}
          setValues={setValues}
          errors={educationErrors}
          setErrors={setEducationErrors}
          tab="education"
          initValues={{
            graduationId: "",
            graduationName: "",
            graduationInstitute: "",
            universityName: "",
            universityScore: 0,
            dateOfJoining: null,
            dateOfCompletion: null,
          }}
        />
      ),
    },
    {
      label: "Experience",
      form: (
        <MultipleFormsContainer
          values={values}
          setValues={setValues}
          errors={experienceErrors}
          setErrors={setExperienceErrors}
          tab="experience"
          initValues={{
            employerName: "",
            designation: "",
            ctcDrawn: 0,
            expYears: 0,
            expMonths: 0,
            domainSkills: "",
          }}
        />
      ),
    },
    // {
    //   label: "Attachments",
    //   form: (
    //     <AttachmentsForm
    //       values={values}
    //       setValues={setValues}
    //       errors={attachmentsErrors}
    //     />
    //   ),
    // },
  ];

  const validateApplicant = async () => {
    let temp: any = {};
    let exists: boolean;

    await axios
      .get(
        `https://acharyajava.uz/AcharyaInstituteUZB/api/employee/checkMobileNumber/${values.applicant.phone}`
      )
      .then((res) => {
        exists = res.data["Mobile Present"];
      })
      .catch((err) => console.error(err));

    temp.name = values.applicant.name ? "" : "This field is required";
    temp.birthDate =
      values.applicant.birthDate &&
      values.applicant.birthDate.getFullYear() <= new Date().getFullYear() - 18
        ? ""
        : "Must be 18 years or older";
    temp.gender = values.applicant.gender ? "" : "This field is required";
    // temp.phone = /^[0-9]{9}$/.test(values.applicant.phone)
    //   ? ""
    //   : "Invalid phone";

    if (!/^[0-9]{9,12}$/.test(values.applicant.phone))
      temp.phone = "Invalid Number";
    else if (exists) temp.phone = "Mobile / Telegram No. already exists";
    else temp.phone = "";

    temp.email =
      values.applicant.email &&
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        values.applicant.email
      )
        ? "Invalid email"
        : "";

    // else if (exists) temp.email = "Email already exists";
    // else temp.email = "";

    temp.headline = values.applicant.headline ? "" : "This field is required";
    temp.headline = values.applicant.headline ? "" : "This field is required";
    // temp.designationId =
    //   designations.length === 0 || values.applicant.designationId
    //     ? ""
    //     : "This field is required";
    temp.maritalStatus = values.applicant.maritalStatus
      ? ""
      : "This field is required";
    temp.street = /^.{1,50}$/.test(values.applicant.street)
      ? ""
      : "Invalid street";
    // temp.locality = /^.{1,50}$/.test(values.applicant.locality)
    //   ? ""
    //   : "Invalid locality";
    temp.country = values.applicant.country ? "" : "This field is required";
    temp.state =
      states.length === 0 || values.applicant.state
        ? ""
        : "This field is required";
    temp.city =
      cities.length === 0 || values.applicant.city
        ? ""
        : "This field is required";
    // temp.pinCode = /^[0-9]{6}$/.test(values.applicant.pinCode)
    //   ? ""
    //   : "Please enter 6 digits";
    temp.skills = /^(.|\n){1,200}$/.test(values.applicant.skills)
      ? ""
      : "Please enter skills, upto 200 characters.";

    setApplicantErrors({ ...temp });

    return Object.values(temp).every((x) => x === "");
  };
  const validateEducation = () => {
    let flag = true;

    values.education.forEach((obj, index) => {
      let temp: any = {};

      temp.graduationId = obj.graduationId ? "" : "This field is required";
      temp.graduationName = obj.graduationName ? "" : "This field is required";
      // temp.graduationInstitute = obj.graduationInstitute
      //   ? ""
      //   : "This field is required";
      temp.universityName = obj.universityName ? "" : "This field is required";
      temp.universityScore =
        /^([0-9]*[.])?[0-9]+$/.test(obj.universityScore.toString()) &&
        obj.universityScore > 0 &&
        obj.universityScore <= 100
          ? ""
          : "Invalid percentage";
      // temp.dateOfJoining = obj.dateOfJoining ? "" : "This field is required";
      // temp.dateOfCompletion =
      //   obj.dateOfJoining &&
      //   obj.dateOfCompletion &&
      //   obj.dateOfCompletion >= obj.dateOfJoining
      //     ? ""
      //     : "Completion date must be after joining date";

      setEducationErrors((prev) =>
        prev.map((o, i) => {
          if (i === index) {
            return temp;
          }
          return o;
        })
      );

      if (!Object.values(temp).every((x) => x === "")) {
        flag = false;
      }
    });

    return flag;
  };
  const validateExperience = () => {
    let flag = true;
    values.experience.forEach((obj, index) => {
      let temp: any = {};
      temp.employerName = obj.employerName ? "" : "This field is required";
      temp.designation = /^[a-zA-Z\s]+$/.test(obj.designation)
        ? ""
        : "Invalid designation";
      temp.ctcDrawn = /^([0-9]*[.])?[0-9]+$/.test(obj.ctcDrawn.toString())
        ? ""
        : "Invalid number";
      temp.expYears = /^([0-9]*[.])?[0-9]+$/.test(obj.expYears.toString())
        ? ""
        : "Invalid number";
      temp.expMonths =
        /^([0-9]*[.])?[0-9]+$/.test(obj.expMonths.toString()) &&
        parseFloat(obj.expMonths) < 12
          ? ""
          : "Enter less than 12 months";
      temp.domainSkills = /^(.|\n){1,200}$/.test(obj.domainSkills)
        ? ""
        : "Please enter working skills, upto 200 characters.";

      setExperienceErrors((prev) =>
        prev.map((o, i) => {
          if (i === index) {
            return temp;
          }
          return o;
        })
      );
      if (!Object.values(temp).every((x) => x === "")) {
        flag = false;
      }
    });
    return flag;
  };
  const validateAttachments = () => {
    let temp: any = {};

    const res: any = values.attachments.resume;
    const deg: any = values.attachments.degree;
    temp.resume =
      res && res.name.endsWith(".pdf") && res.size < 2000000
        ? ""
        : "Please upload a PDF upto 2 MB";
    temp.degree =
      deg && deg.name.endsWith(".pdf") && deg.size < 2000000
        ? ""
        : "Please upload a PDF upto 2 MB";

    setAttachmentsErrors({ ...temp });

    return Object.values(temp).every((x) => x === "");
  };

  const handleNext = async () => {
    if (activeStep === 0 && (await validateApplicant()))
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    if (activeStep === 1 && validateEducation())
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    if (activeStep === 2 && validateExperience()) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      handleSubmit();
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSubmit = async () => {
    setLoading(true);

    let tempObj: ITempObj = {};

    let jobId: number;

    // applicant details submit
    tempObj.active = 1;
    tempObj.city_id = values.applicant.city ? values.applicant.city.id : null;
    tempObj.country_id = values.applicant.country.id;
    tempObj.dateofbirth = `${values.applicant.birthDate.getDate()}-${
      values.applicant.birthDate.getMonth() + 1
    }-${values.applicant.birthDate.getFullYear()}`;
    tempObj.email = values.applicant.email;
    tempObj.firstname = values.applicant.name;
    tempObj.gender = values.applicant.gender;
    tempObj.key_skills = values.applicant.skills;
    // tempObj.link = values.applicant.link;
    // tempObj.linkedin_id = values.applicant.linkedIn;
    // tempObj.locality = values.applicant.locality;
    tempObj.martial_status = values.applicant.maritalStatus;
    tempObj.mobile = values.applicant.phone;
    // tempObj.pincode = values.applicant.pinCode;
    tempObj.job_type_id = values.applicant.headline.id;
    // tempObj.designation_id = values.applicant.designationId.id;
    tempObj.state_id = values.applicant.state
      ? values.applicant.state.id
      : null;
    tempObj.street = values.applicant.street;

    axios
      .post(
        "https://acharyajava.uz/AcharyaInstituteUZB/api/employee/JobProfile",
        tempObj
      )
      .then((res) => {
        jobId = res.data.job_id;
        submitEducation(jobId)
          .then(() => submitExperience(jobId))
          .then((res) => {
            if (res) setRefNumber(res.data);
            setLoading(false);
          })
          .catch((err) => {
            console.error(err);
            setLoading(false);
          });
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const submitEducation = async (jobId: number) => {
    let tempArray: ITempObj[] = [];

    values.education.forEach((obj) => {
      let tempObj: ITempObj = {};

      tempObj.active = 1;
      tempObj.job_id = jobId;
      tempObj.academic_score = obj.universityScore;
      // tempObj.academic_year_completed = `${obj.dateOfCompletion.getDate()}-${
      //   obj.dateOfCompletion.getMonth() + 1
      // }-${obj.dateOfCompletion.getFullYear()}`;
      // tempObj.academic_year_joining = `${obj.dateOfJoining.getDate()}-${
      //   obj.dateOfJoining.getMonth() + 1
      // }-${obj.dateOfJoining.getFullYear()}`;
      tempObj.graduation_id = obj.graduationId;
      tempObj.graduation = obj.graduationName;
      tempObj.university = obj.universityName;
      // tempObj.school = obj.graduationInstitute;

      tempArray.push(tempObj);
    });

    axios
      .post(
        "https://acharyajava.uz/AcharyaInstituteUZB/api/employee/EducationDetails",
        tempArray
      )
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };
  const submitExperience = async (jobId: number) => {
    let tempArray: ITempObj[] = [];

    values.experience.forEach((obj) => {
      let tempObj: ITempObj = {};

      tempObj.job_id = jobId;
      tempObj.annual_salary_lakhs = parseFloat(obj.ctcDrawn);
      tempObj.designation = obj.designation;
      tempObj.employer_name = obj.employerName;
      tempObj.exp_in_months = parseFloat(obj.expMonths);
      tempObj.exp_in_years = parseFloat(obj.expYears);
      tempObj.skills = obj.domainSkills;

      tempArray.push(tempObj);
    });

    return axios
      .post(
        "https://acharyajava.uz/AcharyaInstituteUZB/api/employee/ExperienceDetails",
        tempArray
      )
      .then((res) => res)
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };
  const submitResume = async (jobId: number) => {
    const formData = new FormData();

    formData.set("file", values.attachments.resume);
    formData.set("job_id", jobId.toString());

    return axios
      .post(
        "https://acharyajava.uz/AcharyaInstituteUZB/api/employee/JobUploadFile",
        formData
      )
      .then((res) => res)
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };
  const submitDegree = async (jobId: number) => {
    const formData = new FormData();

    formData.set("file", values.attachments.degree);
    formData.set("job_id", jobId.toString());

    axios
      .post(
        "https://acharyajava.uz/AcharyaInstituteUZB/api/employee/higherEducationUploadFile",
        formData
      )
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  return (
    <Paper elevation={2} sx={{ borderRadius: 3 }} className={classes.paper}>
      {isMobile ? (
        <MobileFormStepper
          steps={steps}
          activeStep={activeStep}
          loading={loading}
          refNumber={refNumber}
          handleNext={handleNext}
          handleBack={handleBack}
        />
      ) : (
        <DesktopFormStepper
          steps={steps}
          activeStep={activeStep}
          loading={loading}
          refNumber={refNumber}
          handleNext={handleNext}
          handleBack={handleBack}
        />
      )}
    </Paper>
  );
}

export default FormStepper;
